module.exports = __webpack_public_path__ + "static/media/find_workspace.920b04ab.gif";